import React, { useContext, useEffect, useState } from "react";
import BackButton from "../components/back_button";
import { AuthContext } from "../contexts/auth"
import { uploadDocumentiSingolo } from "../services/api";
import UploadForm from "../components/upload_form";
import PopoverComponentCustom from "../components/popover_component";
import Footer from "../components/footer";
import ListBoxQueryMultiSelectEmployeesActiveContract from "../components/list_box_query_employee_active_contract";
import { Link } from "wouter";
import DocumentForm from "../components/document_form";


export default function UploadDoc() {
  const { profile, token } = useContext(AuthContext);

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const isProfileComplete = profile.has_complete_profile;

  const handleEmployeeSelection = (employee) => {
    if (!employee || !employee.id) return;
    setSelectedEmployee(employee);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow">
        <PopoverComponentCustom title="Carica documento" />
        {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
          <div className="w-full">
            <div className="bg-orange-100 text-orange-600 p-4 mb-6">
              <p className="text-center text-sm font-semibold">
                Il profilo non è completo. <br />
                Compila i campi mancanti{' '}
                <Link
                  to="/profilo/fatturazione"
                  className="text-indigo-600 hover:text-indigo-800 underline"
                >
                  cliccando qui
                </Link>
              </p>
            </div>
          </div>
        )}

        <main className="flex-grow mt-10 pb-8">
          <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
            <div className="flex items-center my-4">
              <BackButton prevLocation="/documenti" />
            </div>
            <div className="bg-white px-6 lg:px-8 mb-2">
              <div className="mx-auto max-w-2xl text-center space-y-6">

                {/* Titolo */}
                <h2 className="text-lg font-bold tracking-tight text-gray-900">
                  Carica un documento per
                </h2>

                {/* Nome (selezionato) o placeholder */}
                <div className="text-xl font-semibold text-indigo-700" style={{ marginTop: 4, }}>
                  {selectedEmployee
                    ? (
                      selectedEmployee.first_name && selectedEmployee.last_name
                        ? <span className="uppercase">{selectedEmployee.first_name} {selectedEmployee.last_name}</span> 
                        : <span className="uppercase">{selectedEmployee?.cf}</span> 
                    )
                    : 'Seleziona dipendente'}
                  {/* Email (se presente) */}
                  {selectedEmployee?.email_auth && (
                    <p className="text-sm leading-8 text-gray-600">
                      {selectedEmployee.email_auth}
                    </p>
                  )}
                </div>

                {/* ListBox oppure Reset */}
                {!selectedEmployee ? (
                  <div className="flex justify-center" style={{ marginTop: 4, }}>
                    <div className="w-64">
                      <ListBoxQueryMultiSelectEmployeesActiveContract
                        token={token}
                        selectedEmployees={[]}
                        onChange={(sel) => handleEmployeeSelection(
                          Array.isArray(sel) ? sel[0] : sel
                        )}
                        employeeRolePairs={[]}
                        placeholder="Cerca dipendente..."
                        filterBy="all"
                        pageSize={10}
                      />
                    </div>
                  </div>
                ) : (
                  <button
                    onClick={() => setSelectedEmployee(null)}
                    className="inline-flex items-center gap-1 rounded-md bg-indigo-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none"
                  >
                    Reset dipendente
                  </button>
                )}
              </div>
            </div>

            <div
              className={`bg-white rounded-lg shadow overflow-hidden p-6 transition-all duration-300 ${
                !selectedEmployee ? 'opacity-50' : ''
              }`}
            >
              <DocumentForm
                employee={selectedEmployee}
                disabled={!selectedEmployee}
              />
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}